module.exports = __webpack_public_path__ + "assets/a95ca4f4b5bfc7ad7cb61a2c500f2740.svg";